export const api_auth_routes = {
  login: "/auth/login",
};

export const api_guards_routes = {
  getAll_and_create: "/guards",
};

export const api_buildings_routes = {
  getAll_and_create: "/building",
};

export const api_tenants_routes = {
  getAll_and_create: "/tenants",
};

export const api_users_routes = {
  getAll_and_create: "/users",
};
export const api_admin_routes = {
  admin: "/dashboard/admins",
};
export const api_super_admin_routes = {
  create: "/dashboard/superadmin",
  get: "/dashboard/superadmins",
  delete: "/dashboard/superadmin/:id",
  update: "/dashboard/superadmin/:id",
};
